"use client";

import { PexLogo } from "@pex/design-tokens";
import { Button } from "@pex/ui-web";
import { ArrowRight } from "lucide-react";
import { useState } from "react";

interface WelcomeScreenProps {
  onContinue: () => void;
}

export function WelcomeScreen({ onContinue }: WelcomeScreenProps) {
  const [exiting, setExiting] = useState(false);

  const handleContinue = () => {
    setExiting(true);
    setTimeout(onContinue, 380);
  };

  return (
    <div
      className="fixed inset-0 flex flex-col"
      style={{
        background:
          "linear-gradient(180deg, var(--brand-yellow-lightest) 0%, var(--background) 60%)",
        ...(exiting
          ? { animation: "fade-scale-out 0.38s ease-in forwards" }
          : {}),
      }}
    >
      {/* Header — matches TypeformShell exactly */}
      <div
        className="flex items-center px-4 py-3"
        style={{ animation: "slide-up-in 0.6s ease-out both" }}
      >
        <PexLogo className="h-9 w-auto text-foreground" />
      </div>

      {/* Content + button — centred together, matching orientation intro pattern */}
      <div
        className="flex flex-1 flex-col items-center justify-center px-4 pb-[60px]"
        style={{ animation: "slide-up-in 0.6s ease-out 0.14s both" }}
      >
        <div className="flex w-full max-w-sm flex-col items-center gap-6 text-center">
          <div className="flex flex-col gap-3">
            <h1
              className="font-bold text-foreground tracking-tight"
              style={{
                fontSize: "clamp(2.5rem, 8vw, 3.5rem)",
                lineHeight: 1.05,
              }}
            >
              Welcome.
            </h1>
            <p className="font-medium text-lg text-muted-foreground">
              Let's get you checked in. If it's your first time, we have a few
              extra questions to get you set up today, which will make your next
              visit much faster.
            </p>
          </div>

          <Button
            className="h-14 w-full cursor-pointer rounded-full bg-[#feb240] font-semibold text-base text-white transition-transform duration-150 hover:bg-[#e8a030] active:scale-[0.97]"
            onClick={handleContinue}
            type="button"
          >
            Get Started
            <ArrowRight className="ml-1.5 h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
